import script from "./PolicySectionsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolicySectionsPage.vue?vue&type=script&setup=true&lang=ts"

import "./PolicySectionsPage.vue?vue&type=style&index=0&id=6f0d0924&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f0d0924"]])

export default __exports__